import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/images/uniwallet.svg?url";
const SvgUniwallet = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("g", {
  clipPath: "url(#clip0_12510_20313)"
}, /* @__PURE__ */ React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 8,
  fill: "white"
}), /* @__PURE__ */ React.createElement("g", {
  filter: "url(#filter0_f_12510_20313)"
}, /* @__PURE__ */ React.createElement("circle", {
  cx: 13.0526,
  cy: 14.3159,
  r: 14.7368,
  fill: "url(#paint0_radial_12510_20313)"
})), /* @__PURE__ */ React.createElement("g", {
  filter: "url(#filter1_d_12510_20313)"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17.3968 5.20882C17.422 4.76813 17.482 4.47745 17.6027 4.21199C17.6505 4.10692 17.6952 4.02092 17.7021 4.02092C17.709 4.02092 17.6883 4.09848 17.656 4.19325C17.5682 4.45088 17.5538 4.80325 17.6143 5.21322C17.691 5.7334 17.7346 5.80845 18.2868 6.37036C18.5459 6.63392 18.8472 6.96633 18.9564 7.10904L19.155 7.36853L18.9564 7.18308C18.7135 6.9563 18.155 6.51402 18.0316 6.4508C17.9489 6.40839 17.9366 6.40913 17.8856 6.45969C17.8385 6.50629 17.8286 6.5763 17.8221 6.90727C17.812 7.4231 17.7413 7.7542 17.5709 8.08526C17.4787 8.26432 17.4642 8.2261 17.5476 8.02399C17.6099 7.87309 17.6162 7.80675 17.6157 7.30739C17.6148 6.30405 17.4951 6.06284 16.7935 5.64963C16.6157 5.54495 16.3229 5.39399 16.1427 5.31414C15.9625 5.23428 15.8193 5.16473 15.8245 5.15954C15.8444 5.13985 16.5287 5.33869 16.8041 5.44416C17.2138 5.60105 17.2814 5.62138 17.3311 5.60246C17.3645 5.58977 17.3806 5.49307 17.3968 5.20882Z",
  fill: "url(#paint1_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.74107 3.74916C8.49804 3.7117 8.48779 3.7073 8.60216 3.68984C8.82133 3.65634 9.33884 3.70199 9.69547 3.78626C10.528 3.98291 11.2856 4.48669 12.0943 5.38141L12.3091 5.6191L12.6165 5.57C13.9112 5.36324 15.2284 5.52756 16.3301 6.0333C16.6331 6.17243 17.111 6.44939 17.1707 6.52056C17.1897 6.54324 17.2246 6.68925 17.2483 6.84505C17.3301 7.38407 17.2892 7.79723 17.1233 8.10582C17.033 8.27375 17.0279 8.32696 17.0886 8.47068C17.1371 8.58536 17.2722 8.67024 17.4059 8.67005C17.6797 8.66969 17.9744 8.2299 18.1109 7.61798L18.1651 7.37491L18.2726 7.49585C18.8619 8.15934 19.3248 9.06419 19.4043 9.70827L19.425 9.87619L19.326 9.72353C19.1555 9.46083 18.9842 9.28201 18.7648 9.13777C18.3694 8.87779 17.9514 8.78931 16.8441 8.73133C15.8441 8.67897 15.2782 8.59409 14.717 8.41224C13.7621 8.10289 13.2808 7.69089 12.1466 6.21216C11.6428 5.55535 11.3314 5.19195 11.0217 4.8993C10.3179 4.23435 9.62632 3.88561 8.74107 3.74916Z",
  fill: "url(#paint2_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.21314 6.92984C8.71977 6.25487 8.41451 5.21998 8.4806 4.44636L8.50103 4.20696L8.61333 4.22732C8.82423 4.26555 9.18786 4.40004 9.35813 4.50281C9.82539 4.78481 10.0277 5.15608 10.2335 6.10945C10.2938 6.38869 10.3729 6.7047 10.4092 6.81168C10.4678 6.98388 10.6892 7.38612 10.8692 7.64735C10.9989 7.83549 10.9127 7.92464 10.6262 7.89893C10.1885 7.85967 9.59561 7.45307 9.21314 6.92984Z",
  fill: "url(#paint3_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.7978 11.9533C14.4921 11.0308 13.6801 10.2301 13.6801 8.87901C13.6801 8.68019 13.687 8.51751 13.6954 8.51751C13.7038 8.51751 13.793 8.58313 13.8936 8.66334C14.3611 9.03598 14.8847 9.19514 16.3341 9.40526C17.187 9.52892 17.667 9.62879 18.1097 9.7747C19.517 10.2385 20.3877 11.1797 20.5953 12.4616C20.6557 12.8341 20.6203 13.5327 20.5225 13.9008C20.4452 14.1916 20.2096 14.7157 20.1471 14.7358C20.1298 14.7414 20.1128 14.6754 20.1083 14.5856C20.0846 14.1043 19.8398 13.6356 19.4287 13.2846C18.9613 12.8854 18.3333 12.5677 16.7978 11.9533Z",
  fill: "url(#paint4_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M15.1791 12.3366C15.1503 12.1657 15.1002 11.9476 15.0678 11.8518L15.009 11.6776L15.1182 11.7995C15.2695 11.9681 15.389 12.184 15.4902 12.4714C15.5675 12.6908 15.5762 12.7561 15.5757 13.1126C15.5751 13.4626 15.5654 13.536 15.494 13.7335C15.3815 14.0449 15.2418 14.2657 15.0074 14.5027C14.5863 14.9286 14.0448 15.1645 13.2633 15.2623C13.1275 15.2793 12.7316 15.3079 12.3836 15.3259C11.5065 15.3712 10.9292 15.4649 10.4105 15.6459C10.3359 15.6719 10.2693 15.6877 10.2626 15.681C10.2416 15.6603 10.5947 15.4511 10.8864 15.3114C11.2978 15.1145 11.7072 15.0071 12.6246 14.8553C13.0778 14.7803 13.5458 14.6893 13.6646 14.6531C14.7869 14.3111 15.3638 13.4288 15.1791 12.3366Z",
  fill: "url(#paint5_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.2361 14.2019C15.9298 13.5475 15.8594 12.9156 16.0272 12.3264C16.0452 12.2634 16.0741 12.2119 16.0914 12.2119C16.1088 12.2119 16.1811 12.2507 16.2521 12.2982C16.3932 12.3926 16.6763 12.5517 17.4306 12.9603C18.3719 13.4703 18.9085 13.8652 19.2735 14.3163C19.5931 14.7114 19.7909 15.1614 19.8861 15.7101C19.94 16.0209 19.9084 16.7688 19.8281 17.0818C19.5751 18.0686 18.9869 18.8438 18.148 19.2961C18.0251 19.3624 17.9147 19.4168 17.9028 19.4171C17.8908 19.4173 17.9356 19.3041 18.0023 19.1656C18.2845 18.5794 18.3167 18.0092 18.1033 17.3745C17.9727 16.9858 17.7063 16.5116 17.1685 15.7102C16.5432 14.7784 16.3899 14.5304 16.2361 14.2019Z",
  fill: "url(#paint6_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7.57574 17.7327C8.43136 17.0148 9.49596 16.5048 10.4657 16.3482C10.8836 16.2808 11.5799 16.3075 11.9669 16.406C12.5872 16.5637 13.1421 16.9171 13.4307 17.3381C13.7128 17.7495 13.8338 18.1081 13.9597 18.9058C14.0094 19.2205 14.0635 19.5365 14.0799 19.608C14.1745 20.0215 14.3586 20.3519 14.5867 20.5179C14.9491 20.7815 15.5731 20.7979 16.1869 20.5599C16.2911 20.5195 16.3815 20.4916 16.3879 20.4979C16.4101 20.5199 16.101 20.7255 15.883 20.8337C15.5896 20.9794 15.3563 21.0357 15.0463 21.0357C14.4841 21.0357 14.0173 20.7515 13.6279 20.172C13.5512 20.058 13.379 19.7164 13.2451 19.413C12.8339 18.481 12.6308 18.1971 12.1534 17.8863C11.7379 17.616 11.202 17.5675 10.7989 17.764C10.2694 18.0219 10.1216 18.6944 10.5009 19.1205C10.6516 19.2899 10.9327 19.436 11.1626 19.4644C11.5926 19.5175 11.9621 19.1925 11.9621 18.761C11.9621 18.4809 11.8538 18.3211 11.581 18.1988C11.2085 18.0317 10.808 18.227 10.81 18.5747C10.8108 18.723 10.8758 18.8162 11.0254 18.8834C11.1213 18.9266 11.1235 18.93 11.0453 18.9138C10.7035 18.8434 10.6234 18.4339 10.8982 18.1621C11.2282 17.8357 11.9105 17.9797 12.1448 18.4252C12.2432 18.6123 12.2546 18.9849 12.1688 19.2099C11.9768 19.7136 11.4167 19.9784 10.8486 19.8343C10.4618 19.7361 10.3044 19.6299 9.83802 19.1526C9.02768 18.3231 8.7131 18.1624 7.54487 17.9811L7.32101 17.9464L7.57574 17.7327Z",
  fill: "url(#paint7_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.77354 2.88677C6.47968 6.15059 8.34354 7.49719 8.55067 7.78169C8.72168 8.0166 8.65732 8.2278 8.36434 8.39331C8.20142 8.48533 7.86646 8.57858 7.69875 8.57858C7.50906 8.57858 7.44394 8.50586 7.44394 8.50586C7.33395 8.40221 7.27201 8.42033 6.70721 7.42408C5.92308 6.215 5.26687 5.21202 5.24896 5.19523C5.20757 5.15639 5.20828 5.15771 6.62725 7.68067C6.85652 8.20652 6.67286 8.39954 6.67286 8.47443C6.67286 8.62679 6.63103 8.70687 6.4419 8.91651C6.1266 9.26604 5.98566 9.65877 5.88391 10.4716C5.76985 11.3827 5.44913 12.0263 4.56029 13.1279C4.04 13.7727 3.95486 13.8909 3.82358 14.1508C3.65821 14.478 3.61274 14.6613 3.59431 15.0746C3.57484 15.5116 3.61277 15.7938 3.74711 16.2116C3.86472 16.5774 3.98749 16.8189 4.30133 17.3019C4.57217 17.7188 4.72812 18.0285 4.72812 18.1497C4.72812 18.2461 4.74665 18.2463 5.16634 18.1521C6.17072 17.9267 6.98627 17.5303 7.44495 17.0446C7.72882 16.7439 7.79546 16.5778 7.79762 16.1658C7.79904 15.8963 7.7895 15.8399 7.71619 15.6848C7.59685 15.4325 7.3796 15.2227 6.90076 14.8974C6.27336 14.4712 6.00538 14.1281 5.93136 13.6562C5.87064 13.269 5.94108 12.9958 6.28817 12.273C6.64742 11.5247 6.73645 11.2059 6.79667 10.4517C6.83557 9.9644 6.88943 9.77223 7.03032 9.61798C7.17725 9.45714 7.30953 9.40267 7.67316 9.3533C8.266 9.27282 8.64349 9.1204 8.95378 8.83627C9.22296 8.58978 9.3356 8.35227 9.35288 7.99474L9.366 7.72374L9.21558 7.54946C8.67084 6.9183 3.40873 2.39062 3.37521 2.39062C3.36805 2.39062 3.5473 2.61391 3.77354 2.88677ZM5.03391 15.569C5.15708 15.3523 5.09164 15.0736 4.88562 14.9375C4.69096 14.8089 4.38857 14.8694 4.38857 15.0371C4.38857 15.0882 4.41703 15.1254 4.48117 15.1583C4.58918 15.2135 4.59702 15.2756 4.51204 15.4025C4.42598 15.531 4.43293 15.6441 4.53164 15.7209C4.69074 15.8447 4.91596 15.7766 5.03391 15.569Z",
  fill: "url(#paint8_linear_12510_20313)"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.74013 9.49546C9.46182 9.5804 9.19129 9.87351 9.10754 10.1808C9.05645 10.3683 9.08544 10.6972 9.16196 10.7988C9.28559 10.9629 9.40515 11.0061 9.72887 11.0038C10.3627 10.9994 10.9136 10.7293 10.9777 10.3916C11.0302 10.1148 10.7882 9.73123 10.4549 9.56281C10.2829 9.47595 9.91711 9.44148 9.74013 9.49546ZM10.481 10.0712C10.5788 9.93317 10.536 9.78402 10.3698 9.68314C10.0532 9.49106 9.57452 9.65001 9.57452 9.94718C9.57452 10.0951 9.82416 10.2565 10.053 10.2565C10.2053 10.2565 10.4137 10.1662 10.481 10.0712Z",
  fill: "url(#paint9_linear_12510_20313)"
}))), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", {
  id: "filter0_f_12510_20313",
  x: -72.277,
  y: -71.0137,
  width: 170.659,
  height: 170.659,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
  stdDeviation: 35.2964,
  result: "effect1_foregroundBlur_12510_20313"
})), /* @__PURE__ */ React.createElement("filter", {
  id: "filter1_d_12510_20313",
  x: -20.2828,
  y: -21.2671,
  width: 64.5655,
  height: 65.9605,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", null), /* @__PURE__ */ React.createElement("feGaussianBlur", {
  stdDeviation: 11.8289
}), /* @__PURE__ */ React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.605405 0 0 0 0.15 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_12510_20313"
}), /* @__PURE__ */ React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_12510_20313",
  result: "shape"
})), /* @__PURE__ */ React.createElement("radialGradient", {
  id: "paint0_radial_12510_20313",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.0719 14.2967) rotate(42.4693) scale(16.2421)"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "white"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD8EF",
  stopOpacity: 0.4
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint1_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint2_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint3_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint4_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint5_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint6_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint7_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint8_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("linearGradient", {
  id: "paint9_linear_12510_20313",
  x1: 19.7578,
  y1: 18.1172,
  x2: 4.89844,
  y2: 3.67969,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
  stopColor: "#FFCDF1"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 0.380969,
  stopColor: "#F436DA"
}), /* @__PURE__ */ React.createElement("stop", {
  offset: 1,
  stopColor: "#F356EF"
})), /* @__PURE__ */ React.createElement("clipPath", {
  id: "clip0_12510_20313"
}, /* @__PURE__ */ React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 8,
  fill: "white"
}))));
export {SvgUniwallet as ReactComponent};
export default svgUrl;
